<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {},
    es: {},
  },
  components: {
    Layout,
  },
  data() {
    return {
      polls: null,
    };
  },
  methods: {
    getList() {
      api.get("polls").then((response) => {
        if (response.data.status === "success") {
          this.polls = response.data.list;
        } else {
          this.polls = [];
        }
      }).catch(() => {
        this.polls = [];
      });
    },
    timeLeft(dateEnd) {
      const end  = new Date(dateEnd);
      const now  = new Date();
      const diff = end - now;

      if (diff <= 0) return "Encerrado";

      const days    = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours   = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (days > 0)  return `${days}d ${hours}h restantes`;
      if (hours > 0) return `${hours}h ${minutes}min restantes`;
      return `${minutes}min restantes`;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("pt-BR", {
        day: "2-digit", month: "2-digit", year: "numeric",
        hour: "2-digit", minute: "2-digit",
      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t("Enquetes") }}</h3>
        <p></p>
      </div>
    </div>

    <div v-if="!polls" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="polls.length === 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" style="fill: #ccc;">
            <path d="M20 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zm0 16H4V5h16v14z"></path>
            <path d="M6 7h12v2H6zm0 4h12v2H6zm0 4h6v2H6z"></path>
          </svg>
          <p class="mt-2 text-muted">Nenhuma enquete disponível.</p>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row">
        <div class="col-md-6 col-lg-4" v-for="(poll, index) in polls" :key="index">
          <router-link tag="div" :to="'/polls/' + poll.id" class="poll-card-link">
            <div class="card poll-card" :class="{ 'poll-voted': poll.already_voted }">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-2">
                  <span v-if="poll.already_voted" class="badge badge-success text-uppercase">Votado</span>
                  <span v-else class="badge badge-warning text-uppercase text-white">Pendente</span>
                  <span class="poll-type-badge">
                    <svg v-if="poll.type === 'single'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      <path d="M9.999 13.587 7.7 11.292l-1.412 1.416 3.713 3.705 6.706-6.706-1.414-1.414z"></path>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 5H21V7H7zM7 11H21V13H7zM7 17H21V19H7zM3 4H5V6H3zM3 10H5V12H3zM3 16H5V18H3z"></path>
                    </svg>
                  </span>
                </div>

                <h5 class="poll-title">{{ poll.title }}</h5>
                <p v-if="poll.description" class="poll-description text-muted" v-html="poll.description"></p>

                <div class="poll-footer d-flex justify-content-between align-items-center mt-3">
                  <small class="text-muted">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" class="mr-1">
                      <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                      <path d="M13 7h-2v5.414l3.293 3.293 1.414-1.414L13 11.586z"></path>
                    </svg>
                    {{ timeLeft(poll.date_end) }}
                  </small>
                  <span class="poll-action">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"></path>
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.poll-card-link {
  cursor: pointer;
  display: block;
  text-decoration: none;
  color: inherit;
}

.poll-card {
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border-left: 4px solid #556ee6;
}

.poll-card.poll-voted {
  border-left-color: #34c38f;
  opacity: 0.85;
}

.poll-title {
  font-size: 15px;
  font-weight: 600;
  margin: 8px 0 4px;
  line-height: 1.4;
}

.poll-description {
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 0;
}

.poll-type-badge {
  color: #aaa;
}

.poll-action {
  color: #556ee6;
}
</style>
